import { AxiosError } from "axios";

import type { UserProgressionStateModel } from "@/api/generated/models";

// Backend refusals that reset the progression back to an earlier step and return it on the error,
// so the client renders that step instead of stranding the user on a loading/redirect screen:
// - entitlement_required / visit_selection_mismatch: visit creation refused (402/409), reset to
//   visit selection
// - missing_insurance_data: checkout can't be priced because insurance eligibility data is
//   missing/stale (422), reset to payment selection
export const PROGRESSION_RESET_ERROR_CODES = new Set([
  "entitlement_required",
  "visit_selection_mismatch",
  "missing_insurance_data",
]);

// Pulls the reset progression off a backend refusal so the caller can render the step it was reset
// to. Returns null for anything that isn't one of PROGRESSION_RESET_ERROR_CODES.
export const getResetProgressionFromError = (
  error: unknown,
): UserProgressionStateModel | null => {
  if (!(error instanceof AxiosError)) return null;
  const detail = (
    error.response?.data as {
      detail?: { code?: string; progression?: UserProgressionStateModel };
    }
  )?.detail;
  if (!detail?.code || !PROGRESSION_RESET_ERROR_CODES.has(detail.code)) {
    return null;
  }
  return detail.progression ?? null;
};
